import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

interface NavbarTabProps {
  to: string;
  label: string;
  icon: string;
  defaultColor: string;
  hoverColor: string;
  hoverGradient: string;
  showIconOnDefault?: boolean;
  className?: string;
}

const NavbarTab: React.FC<NavbarTabProps> = ({
  to,
  label,
  icon,
  defaultColor,
  hoverColor,
  hoverGradient,
  showIconOnDefault = false,
  className = ''
}) => {
  const location = useLocation();
  
  // Special case for "Create a Story" tab
  let isActive = location.pathname === to;
  if (label === 'Create a Story' && (
    location.pathname.startsWith('/create/2-preferences') || 
    location.pathname.startsWith('/create/3-review')
  )) {
    isActive = true;
  }
  
  // Generate unique class name based on label for specific styling
  const tabClassName = `navbar-tab-${label.toLowerCase().replace(/\s+/g, '-')}`;
  
  // Apply custom styles to this specific tab
  const customStyles = `
    /* Default state */
    .${tabClassName} .navbar-tab-text {
      color: ${defaultColor};
      text-decoration: none;
    }
    
    /* Hover state (changes text color and adds underline) */
    .${tabClassName}:hover:not(.active) .navbar-tab-text {
      color: ${hoverColor};
      text-decoration: underline;
      text-decoration-color: ${hoverColor};
      text-underline-offset: 4px;
      text-decoration-thickness: 2px;
    }
    
    /* Active state (changes background, shows icon) */
    .${tabClassName}.active .navbar-tab-text {
      color: ${hoverColor};
      text-decoration: none;
    }
    .${tabClassName}.active .navbar-tab-bg {
      background: ${hoverGradient};
      border-top: 4px solid ${hoverColor};
      padding-top: 10px;
      border-radius: 0;
      max-height: 72px;
      box-sizing: border-box;
      overflow: hidden;
    }
    .${tabClassName}.active .navbar-tab-icon {
      filter: brightness(0) saturate(100%) invert(36%) sepia(75%) saturate(1000%) hue-rotate(${
        label === 'Home' ? '270deg' : 
        label === 'My Stories' || label === 'Create a Story' ? '190deg' : 
        '30deg'
      }) brightness(100%) contrast(95%);
    }
  `;
  
  return (
    <>
      <style>{customStyles}</style>
      <Link 
        to={to} 
        className={`navbar-tab ${tabClassName} ${isActive ? 'active' : ''} ${className}`}
      >
        <div className="navbar-tab-bg">
          <img 
            src={icon} 
            alt={label} 
            className="navbar-tab-icon"
            style={{ display: isActive ? 'block' : 'none' }}
          />
          <span className="navbar-tab-text">{label}</span>
        </div>
      </Link>
    </>
  );
};

export default NavbarTab; 